<script>
    import MatrimonialForm from "../forms/MatrimonialForm.svelte";
    import MyMatrimonials from "../forms/MyMatrimonials.svelte"
    import _MFS from "../data/MatrimonialFormData"
    let showForm = false
    let fetchAction = null
    let reload = 0
    let MFS = _MFS

    export let showOnPx = 150;
    let hidden = true;

    function goTop() {
        document.body.scrollIntoView();
    }

    function scrollContainer() {
        return document.documentElement || document.body;
    }

    function handleOnScroll() {
        if (!scrollContainer()) {
        return;
        }

        if (scrollContainer().scrollTop > showOnPx) {
        hidden = false;
        } else {
        hidden = true;
        }
    }



</script>


<div class:ds-ht-100={showForm}>
    <div class="ds-contol-buttons">
        {#if showForm}
        <button on:click={()=>{fetchAction = "create";showForm = false;}}>Close Form x</button>
        {:else}
        <button on:click={()=>{fetchAction = "create";showForm = true;}}>+ Add Groom/Bride</button>
        {/if}
        
    </div>
    
    {#if showForm}
    <MatrimonialForm {MFS} {fetchAction} on:formUpdate={()=>{
        reload = reload+1
        showForm = false
        fetchAction = null
        
        }}/>
    {/if}
</div>

<MyMatrimonials on:edit={({detail})=>{
   
    MFS = detail.data;
    fetchAction = "update";
    showForm = true;
    goTop();




    }} {reload}  />


<style lang="scss">
    
   .ds-contol-buttons {
   background-color: rgba(0, 0, 0, 0.413);
   padding: 2.5%;
   display: flex;
   justify-content: center;

   button {
    padding: 10px;
    text-align: center;
    background-color: #FF9933;
    color: #5e2f00;
    font-weight: bold;
    box-shadow: 1px 1px 5px #000;
    transition:box-shadow ease 0.3s ;

    &:active {
        box-shadow: 0px 0px 1px #000;
    }
   }
}

.ds-ht-100 {
    height: 100vh;
    overflow: scroll;
    position: fixed;
    width: 100vw;
    z-index: 100;
}
</style>